<template>
  <div class="video-player mt-4">
    <div class="row">
      <div :class="'col-12 pr-md-0 player' + (playlist ? ' col-lg-8' : '')">
        <Player 
          :src='src'
          :title='title'
          :subtitle='subtitle'
          :id='id'
          :time='time'
          :type='type'
          :auto-play='autoPlay'
          :update-play-time='updatePlayTime'
          :update-play-time-url='updatePlayTimeUrl'
          :is-live='isLive'
        />
      </div>
      <!-- /.flowplayer -->
      <div :class="'col-12 playlist' + (playlist ? ' col-lg-4' : '')" v-if="playlist">
        <el-collapse v-model="collapseActive">
          <el-collapse-item :title="playlistTitle || 'Playlist'" name="1">
            <perfect-scrollbar style="height: 450px;" ref='playlistScroll'>
              <div class="playlist-items">
                <div class="card no-radius" v-for="(item, k) in playlist" :key="k">
                  <router-link class="row no-gutters align-items-center" 
                    active-class="active"
                    exact
                    :to='item.url'
                  >
                    <div class="col-2 text-center" v-if='item.thumbnail'>
                      <img :src="item.thumbnail" class="card-img" :alt="item.title">
                    </div>
                    <div class="col-10">
                      <div class="card-body">
                        <h5 class="card-title">{{ item.title }}</h5>
                        <p class="card-text playlist-genre" v-if='item.genre'>
                          {{ item.genre || '' }}
                        </p>
                        <p class="card-text" v-if='item.category'><small class="text-muted">
                          {{ item.category }}
                        </small></p>
                      </div>
                    </div>
                  </router-link>
                </div>
                <!-- /.card -->
              </div>
            </perfect-scrollbar>
          </el-collapse-item>
        </el-collapse>
        <!-- /.playlist-items -->
      </div>
      <!-- /.col-12 -->
    </div>
    <div class='row pt-3'>
      <div class="col-3 col-lg-2">
        <img 
          :src="thumbnail" 
          :alt="title"
          class='vp-movie-thumbnail'
        />
      </div>
      <div class="col-9 col-lg-10">
        <h1>{{ title }}</h1>
        <span v-if="isLive" class="live-span">
          <span class="live-dot"></span>
          Live 
        </span>
        <el-rate
          :value="rating / 2"
          disabled
          show-score
          text-color="#ff9900"
          :score-template="rating"
          v-if="rating">
        </el-rate>
        <div class="mt-3">
          <span class="d-inline-block labels" v-if='totalTime'>
            {{ totalTime }}
          </span>
          <span class="d-inline-block labels para" v-if='genre'>
            {{ genre.split(',').join(',&nbsp; ') }}
          </span>
        </div>
        <p class="d-none d-sm-block mt-2 para">
          {{ description }}
        </p>
      </div>
      <div class="col-12 d-sm-none para">
        <hr class="bg-white-50">
        <p class="">
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import Player from './Flowplayer';
import Player from './VideoJS';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import $ from 'jquery';

export default {

  props: {
    // player props
    src: String,
    id: Number,
    time: String,
    autoPlay: {
      type: Boolean,
      default: true
    },
    updatePlayTime: {
      type: Boolean,
      default: true
    },
    updatePlayTimeUrl: {
      type: String,
      default: '/playtime'
    },
    // video details props
    title: String,
    subtitle: String,
    type: String,
    rating: String,
    totalTime: String,
    genre: String,
    description: String,
    thumbnail: String,
    playlist: {
      type: [Object, Array],
      default: null
    },
    isLive: {
      type: Boolean,
      default: false
    },
    // other props
    hasRelated: {
      type: Boolean,
      default: false
    },
    hasCommentFeature: {
      type: Boolean,
      default: false
    },
    playlistTitle: String,
  },

  data() {
    return  {
      collapseActive: '1',
    }
  },

  components: {
    // FlowPlayer,
    PerfectScrollbar,
    Player,
  },

  mounted() {
    const isMobile = this.isSmallerDevice();

    if (isMobile) {
      this.collapseActive = null;
    }

    this.$store.commit('isProgressBar', false);

    const sideListOffset = $('.playlist-items')
      .find('a.active')
      .offset();
    
    if ( this.$refs.playlistScroll ) {
      this.$refs.playlistScroll.$el.scrollTop = sideListOffset ? sideListOffset - 150 : 0;
    }
  },

  methods: {
    
  },


  watch: {
    // $route(t, f) {
    //   log('t,f', t, f);
    // }
  }
  
}
</script>

<style lang="scss" scoped>
h1 {
    font-size: 21px;
    line-height: 26px;
    color: white;
    font-weight: 600;
    
    @media (min-width: 768px) {
      font-size: 41px;
      font-weight: bold;
      line-height: 50px;
    }
}

span.labels {
    border: 1px solid;
    padding: 2px 5px;
    font-size: 13px;
    margin-right: 5px;
    border-radius: 3px;
    margin-bottom: 7px;

    @media (max-width: 768px) {
      font-size: 10px;
      letter-spacing: 1px;
    }
}

.bg-white-50 {
    background: #ffffff30;
}

.vp-movie-thumbnail {
    max-width: 140px;
    width: 100%;
}

.para {
  color: whitesmoke;

  @media (max-width: 768px) {
    font-size: 12px;
    letter-spacing: 1px;
  }
}

.live-dot {
  display: inline-block;
  width: 7px;
  height: 6px;
  background: #67c23a;
  border-radius: 100px;
  margin-right: 3px;
  position: relative;
  top: -1px;
}

.live-span {
  background: #dc3545;
  color: white;
  font-size: 12px;
  display: inline-block;
  position: relative;
  top: -4px;
  font-weight: 600;
  padding: 0px 8px;
  border-radius: 2px;
}



.playlist {
  .playlist-items .card {
    background: #151515;
    margin-bottom: 2px;

    &:hover, > a.active {
      background: #4a90e2;
    }
    
    img {
      max-height: 70px;
      width: auto;
      max-width: 85%;
    }

    .card-title {
        font-size: 14px;
        color: white;
        margin-bottom: 2px;
    }

    .card-text {
        color: white;
        font-weight: 100;
        font-size: 11px;
    }

    > a:hover {
        text-decoration: none;
    }
  }
}
</style>

<style lang="scss">
.video-player {
  .playlist {
    .el-collapse-item__header {
      border: none;
      background: #131212;
      padding-left: 10px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
      padding-right: 10px;
      margin-bottom: 2px;

      &:hover, &.is-active {
        background: #0c0c0c;
      }

      &.is-active {
        color: #C70C13;
      }
    }

    .el-collapse {
        border: none;
    }

    .el-collapse-item__content {
      padding-bottom: 0px;
    }

    .el-collapse-item__wrap {border-bottom: none;}
  }
}
</style>